import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getHwShipment = data => {
  return axios.request({
    url: "/finance/hq/hw/outbound/index",
    method: "post",
    data
  });
};

export const refShipments = data => {
  return axios.request({
    url: "/finance/hq/hw/outbound/recalculate",
    method: "post",
    data
  });
};

export const saveCreateBill = data => {
  return axios.request({
    url: "/finance/hq/hw/outbound/createBill",
    method: "post",
    data
  });
};

export const cancelHangBill = data => {
  return axios.request({
    url: `/finance/hq/hw/outbound/cancelAbnormal`,
    method: "post",
    data
  });
};

export const updateItemsType = data => {
  return axios.request({
    url: `/finance/hq/hw/outbound/changeOrderType`,
    method: "post",
    data
  });
};

export const uploadFile = data => {
  return axios.request({
    url: "/finance/overseas/outbound/updateWeightFinance",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};


export const sync = () => {
  return axios.request({
    url: `/finance/hq/hw/outbound/sync`,
    method: "get",
  });
};